import { FC, useRef, useState } from "react";
import { Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getToken } from "../tokens";

const FILENAME_REGEX = /^ListeAvisQuotidien_\d{8}\.pdf$/;

const UploadFaoPdf: FC = () => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!FILENAME_REGEX.test(file.name)) {
      messageApi.error(
        "Le fichier doit être nommé ListeAvisQuotidien_YYYYMMDD.pdf"
      );
      if (inputRef.current) inputRef.current.value = "";
      return;
    }

    setLoading(true);
    try {
      const { token } = getToken();
      const authHeaders: HeadersInit = token
        ? { Authorization: `Bearer ${token}` }
        : {};

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        "https://melcarnebackend.digipulse.ch/manual_push_fao_pdf",
        { method: "POST", headers: authHeaders, body: formData }
      );

      if (!response.ok) throw new Error(`Server responded ${response.status}`);

      messageApi.success(`${file.name} envoyé avec succès, extraction en cours…`);

      const extractResponse = await fetch(
        "https://melcarnebackend.digipulse.ch/extract_data",
        { method: "GET", headers: authHeaders, cache: 'no-store' }
      );

      if (!extractResponse.ok)
        throw new Error(`extract_data responded ${extractResponse.status}`);

      messageApi.success("Extraction lancée avec succès");
    } catch (err) {
      console.error(err);
      messageApi.error("Erreur lors de l'envoi du fichier");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      {contextHolder}
      <input
        ref={inputRef}
        type="file"
        accept=".pdf"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button
        icon={<UploadOutlined />}
        style={{ backgroundColor: "#3eafff" }}
        loading={loading}
        onClick={() => inputRef.current?.click()}
      >
        Envoyer PDF FAO
      </Button>
    </>
  );
};

export default UploadFaoPdf;
